import axios from 'axios';

export default axios.create({
    withCredentials: true,
    baseURL: '/api/',
    header: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Origin':'true'
    }
});
